import { Vue, Component, Prop, Watch, Model } from 'vue-property-decorator'
import { VAppBar, VBtn, VCard, VIcon, VNavigationDrawer, VSpacer, VToolbarTitle } from 'vuetify/lib'
import './GenericDrawer.scss'
import AlertBasico from '../Alert/AlertBasico'

@Component({
	name: 'GenericDrawer'
})
export class GenericDrawer extends Vue {
	drawer: Boolean = false
	@Prop({ type: [String, Object], required: false }) title!: string | object
	@Prop({ type: Boolean, default: true }) appBar!: boolean
	@Prop({ type: String, required: false, default: 'white' }) headerColor!: string
	@Prop({ type: String, required: false }) widthProp!: string

	get width() {
		if (this.widthProp) return this.widthProp

		const w = this.$vuetify.breakpoint.width

		if (w >= 1366) return '581'
		if (w >= 980 && w <= 1365) return '50%'
		if (w >= 480 && w <= 979) return '80%'
		if (w <= 479) return '100%'
	}

	@Watch('drawer')
	onDrawerChange() {
		this.$emit('update:drawer', this.drawer)
		this.$emit('input', this.drawer)
		this.$emit('drawer', this.drawer)
	}

	emitDrawerState(event: Object) {
		this.$emit('drawerStateChange', this.drawer)
	}

	render() {
		return (
			<VNavigationDrawer
				{...{ attrs: this.$attrs, props: this.$props }}
				vModel={this.drawer}
				clipped
				right
				top
				app
				temporary
				onTransitionend={this.emitDrawerState}
				width={this.width}
				scoledSlots={this.$scopedSlots}
			>
				{this.appBar && (
					<VAppBar elevation="2" absolute style="z-index: 10" color={this.$vuetify.theme.dark ? '#121212' : 'white'} class="px-2">
						<VToolbarTitle class="title-generic-drawer">{this.title}</VToolbarTitle>
						<VSpacer />

						{this.$scopedSlots.actions && this.$scopedSlots.actions(this.$props)}

						<VBtn icon onClick={() => this.closeDrawer()} size="32">
							<VIcon>mdi-close-thick</VIcon>
						</VBtn>
					</VAppBar>
				)}

				{this.$scopedSlots.default ? (
					<VCard elevation="0" style="height: calc(100% - 72px)">
						{this.$scopedSlots.default(this.$props)}
					</VCard>
				) : (
					<AlertBasico message="Erro na renderização" type="error" />
				)}
			</VNavigationDrawer>
		)
	}

	closeDrawer() {
		this.drawer = false
		this.$emit('drawer:closed')
		this.$emit('update:drawer', this.drawer)
	}

	openDrawer() {
		this.drawer = true
		this.$emit('drawer:opened')
		this.$emit('update:drawer', this.drawer)
	}
}

export default GenericDrawer
